import { useService } from 'react-reservice';

import configService from './service';

export const useConfig = () => {
  return useService(configService, (state) => state);
};

export { configService };
